import { render, staticRenderFns } from "./recruitPage.vue?vue&type=template&id=e6ca63d6&"
import script from "./recruitPage.vue?vue&type=script&lang=js&"
export * from "./recruitPage.vue?vue&type=script&lang=js&"
import style0 from "./recruitPage.vue?vue&type=style&index=0&id=e6ca63d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports